module.exports = " <svg :class=classes> <use xmlns:xlink=http://www.w3.org/1999/xlink :xlink:href=id></use> </svg> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Symbol.vue
// module id = 740
// module chunks = 2